export default __webpack_public_path__ + "static/media/img_10.05104ff1.jpg";